import angular from 'angular';

angular.module('webTools').controller('ConfigCtrl', ['$scope', '$ngRedux',
  function($scope, $ngRedux) {
    $scope.store = $ngRedux;
  }
]);
